import { c as _c } from "react/compiler-runtime";
import { useReducer } from 'react';
import { reducer } from './reducer';
import { LineOfCoverageEditorActionType } from './types';
import type { LineOfCoverageTypeDetails } from '../../..';
export interface SelectedLinesOfCoverageHook {
  selectedLineOfCoverageTypeDetails: LineOfCoverageTypeDetails[];
  isDeleting: boolean;
  removeLoc: (index: number) => void;
  addLoc: (lineOfCoverage: LineOfCoverageTypeDetails) => void;
  updateLocDisplayName: (index: number, displayName: string) => void;
}
export function useSelectedLinesOfCoverage(initialLineOfCoverageTypeDetails) {
  const $ = _c(8);
  let t0;
  if ($[0] !== initialLineOfCoverageTypeDetails) {
    t0 = {
      selectedLineOfCoverageTypeDetails: initialLineOfCoverageTypeDetails,
      isDeletingCoverage: false
    };
    $[0] = initialLineOfCoverageTypeDetails;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [state, dispatch] = useReducer(reducer, t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (index, t2) => {
      const isDeleting = t2 === undefined ? false : t2;
      dispatch({
        type: LineOfCoverageEditorActionType.REMOVE_SELECTED_LOC,
        payload: {
          index,
          isDeleting
        }
      });
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const removeLoc = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = lineOfCoverage => {
      dispatch({
        type: LineOfCoverageEditorActionType.ADD_SELECTED_LOC,
        payload: {
          lineOfCoverage
        }
      });
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const addLoc = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (index_0, displayName) => {
      dispatch({
        type: LineOfCoverageEditorActionType.UPDATE_DISPLAY_NAME,
        payload: {
          index: index_0,
          displayName
        }
      });
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const updateLocDisplayName = t3;
  let t4;
  if ($[5] !== state.isDeletingCoverage || $[6] !== state.selectedLineOfCoverageTypeDetails) {
    t4 = {
      selectedLineOfCoverageTypeDetails: state.selectedLineOfCoverageTypeDetails,
      isDeleting: state.isDeletingCoverage,
      removeLoc,
      addLoc,
      updateLocDisplayName
    };
    $[5] = state.isDeletingCoverage;
    $[6] = state.selectedLineOfCoverageTypeDetails;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}